var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-layout-loading"},[_c('v-spinner',{staticClass:"spinner",attrs:{"color":"--blue-grey-300","background-color":"--blue-grey-200"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }